<div
  class="record"
  [ngClass]="{
    wait: isEmAnalise || isEmFechamento,
    success: isAprovada,
    refused: isRecusada,
    sos: isSos,
    'payment-date': isPagamentoAgendado
  }"
>
  <div
    class="head"
    [ngClass]="{
      'blue-bg': proposta.status.id === 31 && isParceiro,
      'orange-bg':
        (proposta.status.id === 32 ||
          proposta.status.id === 33) &&
        isParceiro
    }"
  >
    <div class="flex-container">
      <span
        *ngIf="proposta.capturedEfetive"
        class="icon-omni-efetive-mais icon-pesados-brasil margin-left-12"
      ></span>
      <span
        class="icon-pesados-brasil margin-left-12"
        [ngClass]="{
          'visibility-hidden':
            tipoPropostaEnum.PROPRIA === proposta.campaign.type,
          'icon-recebido-pesados-brasil':
            tipoPropostaEnum.RECEBIDA === proposta.campaign.type,
          'icon-indicado-pesados-brasil':
            tipoPropostaEnum.INDICADA === proposta.campaign.type
        }"
        [tooltip]="popTemplate"
        triggers="click"
        placement="right"
        containerClass="tooltip"
        (click)="getDadosPesadosBrasil(proposta)"
      ></span>
      <a
        (click)="clickTituloCard()"
        class="margin-auto"
        [ngClass]="{
          'a-none':
            isNoAction || tipoPropostaEnum.INDICADA === proposta.campaign.type
        }"
        [title]="titleTituloCard"
      >
        {{ proposta.status.title }}
      </a>
      <span
        class="icon-pesados-brasil margin-right-12 visibility-hidden"
        [ngClass]="{
          'icon-recebido-pesados-brasil':
            tipoPropostaEnum.RECEBIDA === proposta.campaign.type,
          'icon-indicado-pesados-brasil':
            tipoPropostaEnum.INDICADA === proposta.campaign.type
        }"
      ></span>
      <span
        *ngIf="proposta.capturedEfetive"
        class="icon-omni-efetive-mais icon-pesados-brasil margin-left-12 visibility-hidden"
      ></span>
    </div>
  </div>
  <div class="body">
    <div *ngIf="isCardEsquerdo" class="days col-xs-4">
      <div class="row">
        <div class="col-xs-12">
          <span class="icon"></span>
        </div>
      </div>
      <div *ngIf="isStrongText" class="row">
        <div class="col-xs-12">
          <strong>{{ strongText }}</strong>
        </div>
      </div>
      <div *ngIf="isSmallText" class="row">
        <div class="col-xs-12">
          <small>{{ smallText }}</small>
        </div>
      </div>
      <div *ngIf="isCdclRecusada" class="row">
        <div class="col-xs-12">
          <strong>{{ strongText }}</strong>
        </div>
      </div>
      <div *ngIf="isBotaoAcao" class="row">
        <div class="col-xs-12">
          <a
            (click)="clickBotaoAcao()"
            [title]="botaoAcao"
            class="btn btn-sm"
            >{{ botaoAcao }}</a
          >
        </div>
      </div>
      <div *ngIf="isNovaTentativa" class="row">
        <div class="col-xs-12">
          <span class="fa fa-spinner fa-pulse fa-1x" aria-hidden="true"></span>
          <span>Executando Nova Tentativa...</span>
        </div>
      </div>

      <div *ngIf="isUsuarioAcao" class="row operator">
        <div class="rep col-xs-12 text-left">
          <img
            class="user-photo"
            [src]="proposta.analyst.urlPhoto"
            appFallbackImage
            alt="Imagem do usuário"
          />
          <span class="name">
            <span>
              <small>Analista</small>
              {{ proposta.analyst.name }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <div
      class="infos"
      [ngClass]="{ 'col-xs-8': isCardEsquerdo, 'col-xs-12': !isCardEsquerdo }"
    >
      <!-- Número e data -->
      <div class="card-ficha date">
        <div class="ficha-align text-left">
          Ficha: <span>{{ proposta.id }}</span>
          <span
            *ngIf="proposta.userTypeInclude === 7"
            class="icon store"
          ></span>
        </div>
        <div class="data-align text-right text-left-767 container-info">
          Iniciada:<span>{{ proposta.date | date: 'dd/MM/y' }}</span> |
          <span>{{ proposta.date | date: 'HH:mm' }}</span>
          <app-bell-notification
            [count]="proposta.totalSOS"
          ></app-bell-notification>
        </div>
      </div>
      <!-- Cliente -->
      <div class="row client">
        <div class="col-xs-12 text-left-767">
          <span class="title"> {{proposta?.customer?.type === 'J' ? 'Razão Social' : 'Cliente'}}</span>
          <h2 title="{{ proposta.customer.name }}">
            {{ proposta.customer.name }}
          </h2>
          <span class="user-id"  [ngStyle]="{
            'font-size.rem': proposta.customer.name !== ' ' ? 1.2 : 2.2,
            color: proposta.customer.name !== ' ' ? '#474947' : '#00185c',
            'margin-bottom.px': proposta.customer.name !== ' ' ? 0 : 25
          }" *ngIf="proposta?.customer?.type === 'J'; else cpfTemplateRef">CNPJ: {{ proposta.customer.document | cnpj }}</span>
          <ng-template #cpfTemplateRef >
            <span class="user-id"  [ngStyle]="{
              'font-size.rem': proposta.customer.name !== ' ' ? 1.2 : 2.5,
              color: proposta.customer.name !== ' ' ? '#474947' : '#00185c',
              'margin-bottom.px': proposta.customer.name !== ' ' ? 0 : 13
            }" >CPF: {{ proposta.customer.document | cpf }}</span>
          </ng-template>
        </div>
      </div>
      <!-- Representante -->
      <div *ngIf="proposta.store" class="row operator">
        <div class="col-xs-12 text-left">
          <img
            class="user-photo"
            [src]="proposta?.store?.urlPhoto"
            appFallbackImage
            alt="Imagem do usuário"
          />
          <span class="name" *ngIf="!isParceiro">
            <span>
              <small>{{ proposta?.store?.name | titlecase }}</small>
              {{ proposta?.store?.sellerName | titlecase }}
            </span>
          </span>

          <!-- DELL -->
          <div
            class="action"
            *ngIf="proposta.status.id === 31 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                1,
                this.proposta.id
              ]"
            >
              <span> Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
          <div
            class="action"
            *ngIf="proposta.status.id === 32 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                3,
                this.proposta.id
              ]"
            >
              <span> Verificar Status e Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
          <div
            class="action"
            *ngIf="proposta.status.id === 33 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                3,
                this.proposta.id
              ]"
            >
              <span> Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>

          <!-- FIM DELL -->

        </div>
      </div>
      <!-- Lojista -->
      <div *ngIf="proposta.promoter && !proposta.store" class="row operator">
        <div class="col-xs-12 text-left">
          <img
            class="user-photo"
            [src]="proposta?.promoter?.urlPhoto"
            appFallbackImage
            alt="Imagem do usuário"
          />
          <span class="name">
            <span>
              {{ proposta?.promoter?.name | titlecase }}
            </span>
          </span>
          <div
            class="action"
            *ngIf="proposta.status.id === 31 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                1,
                this.proposta.id
              ]"
            >
              <span> Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
          <div
            class="action"
            *ngIf="proposta.status.id === 32 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                3,
                this.proposta.id
              ]"
            >
              <span> Verificar Status e Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
          <div
            class="action"
            *ngIf="proposta.status.id === 33 && isParceiro"
          >
            <a
              [routerLink]="[
                '/produtos/cdcloja/ecommerce',
                3,
                this.proposta.id
              ]"
            >
              <span> Continuar Preenchimento </span>
            </a>
            <em class="fa fa-chevron-right"></em>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-message
  #modalMessage
  [title]="'Atenção!'"
  [hideClose]="true"
></app-modal-message>

<ng-template #popTemplate>
  <app-loader-default
    text="Buscando informações da proposta"
    [show]="isBuscandoProposta"
    size="fa-1x"
  ></app-loader-default>
  {{ toolTip }}
</ng-template>
